import { render, staticRenderFns } from "./MiniAssetRefresher.vue?vue&type=template&id=22fddca6&scoped=true"
import script from "./MiniAssetRefresher.vue?vue&type=script&lang=js"
export * from "./MiniAssetRefresher.vue?vue&type=script&lang=js"
import style0 from "./MiniAssetRefresher.vue?vue&type=style&index=0&id=22fddca6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fddca6",
  null
  
)

export default component.exports